export default "7d1fa3755f957601.svg"